import React from 'react';
import { css } from '@emotion/react';

import type { RowProps } from 'shared/components/nv-table';
import { almostWhite, shadedWhite } from 'athena/styles/colors';
import OptionsCell from './options-cell';
import ConnectionsCell from './connections-cell';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';
import { config } from '@config/pendo.config.json';
import StatusCell from './status-cell';
import NameCell from './name-cell';
import AvailabilityCell from './availability-cell';

const cells = {
  name: NameCell,
  status: StatusCell,
  assigned: ConnectionsCell,
  availability: AvailabilityCell,
  options: OptionsCell,
};

const ParticipantRow = (props: RowProps<MentoringProgramEnrollment>) => {
  const { row, className, getCellStyle } = props;
  const { original } = row || {};
  const { id } = original || {};

  const styles = css`
    border-bottom: 1px solid ${shadedWhite};

    &:hover {
      background-color: ${almostWhite};

      .options-target {
        opacity: 1;
      }
    }

    &:last-of-type {
      border-bottom: 0;
    }
  `;

  const dataQATag = config.pendo.athena.mentorshipProgram.participants.participantRow;

  return (
    <div css={styles} className={className} data-qa={`${dataQATag}_${id}`}>
      {row.getVisibleCells().map((cell, index) => {
        const CellComponent = cells[cell.column.id];

        return (
          <CellComponent css={getCellStyle(index)} cell={cell} key={cell.id} />
        );
      })}
    </div>
  );
};

export default ParticipantRow;

